import { Environment, OrbitControls } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import { Physics } from '@react-three/rapier';
import TableScene from './TableScene';

export function Game(props: { roomId: string; }) {
  const { roomId } = props;

  return (
    <>
      <div className="flex flex-col w-full min-h-screen">
        <main className="flex-grow relative">
          <div className="absolute inset-0">
            <Canvas shadows camera={{ position: [0, 20, 4], fov: 50 }}>
              <color attach="background" args={['#191c20']} />
              <ambientLight intensity={0.5} />
              <directionalLight
                position={[10, 10, 10]}
                intensity={1}
                castShadow
                shadow-mapSize={[2048, 2048]} />

              <Environment preset="sunset" />
              <Physics debug={false}>
                <TableScene />
              </Physics>

              <OrbitControls makeDefault />
            </Canvas>
          </div>
        </main>
      </div>

      <p className='absolute z-10 top-0 right-0'>{roomId}</p>
    </>
  );
}
